"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = reducer;
const types_1 = require("../types");
const isValidInput = (value, lowerBound, upperBound) => {
    if (value === '')
        return false;
    const numValue = Number(value);
    return (!Number.isNaN(numValue) && numValue >= lowerBound && numValue <= upperBound);
};
function reducer(state, action) {
    var _a, _b, _c, _d;
    switch (action.type) {
        case types_1.ActionType.SLIDER: {
            const dotIndex = (_a = action.dotIndex) !== null && _a !== void 0 ? _a : 0;
            const newDots = [...state.dots];
            newDots[dotIndex] = Object.assign(Object.assign({}, newDots[dotIndex]), { sliderValue: action.value, inputValue: String(action.value), inputIsInValid: false });
            return Object.assign(Object.assign({}, state), { dots: newDots });
        }
        case types_1.ActionType.INPUT: {
            const dotIndex = (_b = action.dotIndex) !== null && _b !== void 0 ? _b : 0;
            const bounds = state.datasetBounds[dotIndex];
            const newDots = [...state.dots];
            newDots[dotIndex] = Object.assign(Object.assign({}, newDots[dotIndex]), { inputValue: action.value, sliderValue: isValidInput(action.value, bounds.lowerBound, bounds.upperBound)
                    ? Number(action.value)
                    : newDots[dotIndex].sliderValue, inputIsInValid: false });
            return Object.assign(Object.assign({}, state), { dots: newDots });
        }
        case types_1.ActionType.SET_INPUT_INVALID: {
            const dotIndex = (_c = action.dotIndex) !== null && _c !== void 0 ? _c : 0;
            const newDots = [...state.dots];
            newDots[dotIndex] = Object.assign(Object.assign({}, newDots[dotIndex]), { inputIsInValid: true });
            return Object.assign(Object.assign({}, state), { dots: newDots });
        }
        case types_1.ActionType.UPDATE_STATE: {
            // Update dot position based on new initialDynamicDots and fallback to fixedDots if initialDynamicDots is not provided
            let updateDots;
            if (action.value.initialDynamicDots) {
                updateDots = action.value.initialDynamicDots.map((dot) => ({
                    sliderValue: dot.x,
                    inputValue: dot.x.toString(),
                    inputIsInValid: false,
                }));
            }
            else {
                updateDots = action.value.fixedDots.map((dot) => ({
                    sliderValue: dot.x,
                    inputValue: dot.x.toString(),
                    inputIsInValid: false,
                }));
            }
            return Object.assign(Object.assign(Object.assign({}, state), action.value), { dots: updateDots });
        }
        case types_1.ActionType.RESET: {
            const dotIndex = (_d = action.dotIndex) !== null && _d !== void 0 ? _d : 0;
            const fixedDot = state.fixedDots[dotIndex];
            if (!fixedDot)
                return state;
            const newDots = [...state.dots];
            newDots[dotIndex] = {
                sliderValue: fixedDot.x,
                inputValue: fixedDot.x.toString(),
                inputIsInValid: false,
            };
            return Object.assign(Object.assign({}, state), { dots: newDots });
        }
        default:
            return state;
    }
}
